export class DistributorOtherKp {
  constructor() { }
  distributerParticipant: string;
  distributerParticipantName: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/distributor-other-kp.ts